export enum EmailEditorPageMode {
  SendRfq = 'SendRfq',
  SendCustomer = 'SendCustomer',
  SendInsured = 'SendInsured',
  SendMarket = 'SendMarket',
  MissingInformationRequest = 'MissingInformationRequest',
  SendSolicitation = 'SendSolicitation',
  UserNotification = 'UserNotification',
  EscalationPolicy = 'EscalationPolicy',
  CannotPursue = 'CannotPursue',
  PositiveExpectation = 'PositiveExpectation',
  NewQuote = 'NewQuote',
  MarketingReport = 'MarketingReport',
  InformationRequestsReport = 'InformationRequestsReport',
  ConceptualTower = 'ConceptualTower',
  Default = 'Default',
  LayerBinder = 'LayerBinder',
  LayerPolicy = 'LayerPolicy',
  BorAcknowledgment = 'BorAcknowledgment',
  RemarketingUpdate = 'RemarketingUpdate',
}
